/* eslint-disable */

/**
 * Supported webhook events for the Automatic Print Agent
 * Easy to extend for other companies later
 */
export const PRINT_AGENT_EVENTS = {
  ecotrack: [
    {
      id: 1,
      event: "order.ready_to_ship",
      key: "ready_to_ship",
      fr: "Prêt à expédier",
    },
    {
      id: 5,
      event: "order.shipping_to_hub",
      key: "shipping_to_hub",
      fr: "Vers hub",
    },
  ],
  zrexpress: [
    {
      id: 1,
      event: "parcel.state.updated",
      key: "ready_to_ship",
      fr: "Prêt à expédier",
      statusFilter: "Prêt à expédier",
    },
    {
      id: 2,
      event: "parcel.state.updated",
      key: "shipping_to_hub",
      fr: "Vers station",
      statusFilter: "Vers station",
    },
  ],
  ecomdelivery: [
    {
      id: 1,
      event: "En Traitement",
      key: "ready_to_ship",
      fr: "Prêt à expédier",
    },
    {
      id: 2,
      event: "Dispatcher",
      key: "shipping_to_hub",
      fr: "Vers hub",
    },
  ],
  guepex: [
    {
      id: 1,
      event: "parcel_status_updated",
      key: "ready_to_ship",
      fr: "Prêt à expédier",
      statusFilter: "Prêt à expédier",
    },
    {
      id: 2,
      event: "parcel_status_updated",
      key: "shipping_to_hub",
      fr: "Vers station",
      statusFilter: "Vers Station",
    },
  ],
};

export const WEBHOOK_BASE_URL = process.env.REACT_APP_BACKEND_DIGITALOCEAN_URL;
